export default {
    'Brûleurs': 'chauffage',
    'Chaudières': 'chauffage',
    'Chauffe-bains': 'chauffage',
    'Chauffe-eau thermodynamique': 'chauffage',
    'Clim - Unités extérieures': 'clim',
    'Clim - Unités intérieures': 'clim',
    'PAC - Unités extérieures': 'clim',
    'PAC - Unités intérieures': 'clim',
    'Régulations': 'regulations'
}